import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDriverProfitability = createAsyncThunk('Client/getDriverProfitability', async (params) => {
 const response = await axios.post('https://api.zasway.com:8443/Profitability/GetDriverProfitability', params, {mode:'cors'})
        
 return {
         params,
         data: response.data.data,
         allData: response.data.allData,
         totalPages: response.data.total,

         totalBookings: response.data.bookings,
         invoiceBookings: response.data.invbookings,
         completedBookings: response.data.cmpbookings,
         futureBookings: response.data.ftrbookings,
         totalAmount: response.data.amount,
         invoiceAmount: response.data.invamount,
         completedAmount: response.data.cmpamount,
         profitAmount: response.data.prfamount,
          daysWorked: response.data.dswrkd,
         driverCommission: response.data.drvrcommsn
       }
  
 })

 export const DriverProfitabilitySlice = createSlice({
    name: 'driverprofitability',
    initialState: {
      data: [],
      clientProfitability: [],
      vehicleProfitability: [],
      driverProfitability: [],
      total: 1,
      params: {},
      allData: [],
      selectedUser: null,
      selectedDocument:[],
      IsSaved:0,
      clientProfitabilityStartDate: [],
      clientProfitabilityEndDate: [],
       Profitabilityclient: [], 
   Profitabilitydriver: [],
   Profitabilitypassenger: [],
   ProfitabilityvehicleType: [], 
   ProfitabilitypaymentMethod: [],

       totalBookings: 0,
         invoiceBookings: 0,
         completedBookings: 0,
         futureBookings: 0,
         totalAmount: 0,
         invoiceAmount: 0,
         completedAmount: 0,
         profitAmount: 0,
         daysWorked: 0,
         driverCommission: 0
    },
    reducers: {},
    extraReducers: builder => {
      builder
      
        .addCase(getDriverProfitability.fulfilled, (state, action) => {
              
          state.data = action.payload.data
          state.params = action.payload.params
          state.total = action.payload.totalPages
            state.totalBookings = action.payload.totalBookings
         state.invoiceBookings = action.payload.invoiceBookings
         state.completedBookings = action.payload.completedBookings
         state.futureBookings = action.payload.futureBookings
         state.totalAmount = action.payload.totalAmount
         state.invoiceAmount = action.payload.invoiceAmount
         state.completedAmount = action.payload.completedAmount
         state.profitAmount = action.payload.profitAmount
         state.daysWorked = action.payload.daysWorked
         state.driverCommission = action.payload.driverCommission
          state.clientProfitabilityStartDate = action.payload.params.startDate
          
          state.clientProfitabilityEndDate = action.payload.params.endDate

            state.Profitabilityclient = action.payload.params.clientID
        state.Profitabilitydriver = action.payload.params.driverID
        state.Profitabilitypassenger = action.payload.params.passengerID
        state.ProfitabilityvehicleType = action.payload.params.vehicleTypeID
        state.ProfitabilitypaymentMethod = action.payload.params.paymentMethodID
        })
    }
  })
  
  
  export default DriverProfitabilitySlice.reducer